import React, { useState } from 'react';
import { Box, Pagination, Typography } from '@mui/material';
import { GestionEtablissementWidget, GestionEtablissementWidgetType } from '../../molecules';

export type GestionEtablissementListProps = {
    items?: Array<GestionEtablissementWidgetType>;
};

const ITEMS_PER_PAGE = 10;

export const GestionEtablissementList: React.FunctionComponent<GestionEtablissementListProps> =
    function (props: GestionEtablissementListProps) {
        const { items } = props;
        const [page, setPage] = useState(1);

        if (!items || items.length === 0) {
            return (
                <Typography
                    variant="body1"
                    sx={{ marginTop: '16px', color: 'text.secondary', fontStyle: 'italic' }}
                >
                    Aucun établissement secondaire existant
                </Typography>
            );
        }

        const totalPages = Math.ceil(items.length / ITEMS_PER_PAGE);
        const paginatedItems = items.slice((page - 1) * ITEMS_PER_PAGE, page * ITEMS_PER_PAGE);

        return (
            <Box>
                {paginatedItems.map((itemProps: GestionEtablissementWidgetType, index) => {
                    // L'index passé au widget est l'index réel dans le tableau complet
                    // et non l'index paginé, pour éviter les erreurs de splice lors
                    // des modifications
                    const realIndex = (page - 1) * ITEMS_PER_PAGE + index;
                    return (
                        <GestionEtablissementWidget
                            key={`gestionEtablissement-${realIndex}`}
                            {...itemProps}
                            index={realIndex}
                        />
                    );
                })}
                {totalPages > 1 && (
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            marginTop: '16px',
                        }}
                    >
                        <Pagination
                            count={totalPages}
                            page={page}
                            onChange={(_, value) => setPage(value)}
                            color="primary"
                            shape="rounded"
                        />
                    </Box>
                )}
            </Box>
        );
    };
